import services from './../../services/service'; // Service
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Policy',
    data () {
        return {
          
        }
    },
    components: {
        'second-header': SecondHeader,
        'main-footer': MainFooter
    },
    
    created: function(){
        
    }
}


// WEBPACK FOOTER //
// ./src/components/Policy/script.js